import { connect } from 'react-redux';
import VoucherWrapper from "../components/general/VoucherWrapper";
import { CHECK_VOUCHER } from "../store/actions/voucher";

const mapStateToProps = state => {
    return {
        voucher: state.voucherR,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        CHECK_VOUCHER: body => dispatch(CHECK_VOUCHER(body)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(VoucherWrapper);


// WEBPACK FOOTER //
// ./src/containers/Voucher.js